/*
  Launch: snow layer (2026-10-20 speed pass).
  Draws the snow tile set on launch-tokens (--launch-snow-src) into a canvas inside every
  .launch-snow layer. Same tile, tile size (--launch-snow-size) and drift cycle
  (--launch-snow-duration) as the old CSS background; opacity still comes from the
  .launch-snow rule in launch-base.css. A canvas is never a Largest Contentful Paint
  candidate, so this decorative layer can no longer be, or delay, the page LCP.
  The drift stops for reduced motion and on .launch-snow--still, and pauses while a
  layer is off screen or the tab is hidden.
*/
(function () {
  'use strict';
  if (window.__launchSnow) return;
  window.__launchSnow = true;

  var rootStyle = getComputedStyle(document.documentElement);
  var src = rootStyle.getPropertyValue('--launch-snow-src').trim().replace(/^["']|["']$/g, '');
  if (!src) return;
  var size = parseFloat(rootStyle.getPropertyValue('--launch-snow-size')) || 760;
  var duration = (parseFloat(rootStyle.getPropertyValue('--launch-snow-duration')) || 60) * 1000;
  var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  var img = new Image();
  var ready = false;
  var layers = [];
  var start = 0;
  var frame = 0;

  function reduced() { return !!(motionQuery && motionQuery.matches); }

  function fit(layer) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = layer.el.clientWidth, h = layer.el.clientHeight;
    layer.w = w; layer.h = h; layer.dpr = dpr;
    layer.canvas.width = Math.max(1, Math.round(w * dpr));
    layer.canvas.height = Math.max(1, Math.round(h * dpr));
  }

  function draw(layer, offset) {
    var ctx = layer.ctx, dpr = layer.dpr, s = size * dpr;
    if (!ctx) return;
    ctx.clearRect(0, 0, layer.canvas.width, layer.canvas.height);
    var y0 = (offset % size) * dpr - s;
    for (var y = y0; y < layer.canvas.height; y += s) {
      for (var x = 0; x < layer.canvas.width; x += s) {
        ctx.drawImage(img, x, y, s, s);
      }
    }
  }

  function moving(layer) {
    return !reduced() && !layer.el.classList.contains('launch-snow--still');
  }

  function offsetNow(now) {
    return ((now - start) % duration) / duration * size;
  }

  /* The drift is slow (one tile per cycle, about 13px a second at the defaults), so 30
     redraws a second look identical to 60 and halve the work. */
  var lastDraw = 0;
  function tick(now) {
    frame = 0;
    var any = false, draw30 = now - lastDraw >= 32;
    for (var i = 0; i < layers.length; i++) {
      var l = layers[i];
      if (l.visible && moving(l)) { if (draw30) draw(l, offsetNow(now)); any = true; }
    }
    if (draw30) lastDraw = now;
    if (any && !document.hidden) frame = requestAnimationFrame(tick);
  }

  function kick() {
    if (!ready || frame || document.hidden) return;
    frame = requestAnimationFrame(tick);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var l = e.target.__snow;
      if (!l) return;
      l.visible = e.isIntersecting;
      if (l.visible && ready && !moving(l)) draw(l, 0);
    });
    kick();
  }) : null;

  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) {
      var l = e.target.__snow;
      if (!l) return;
      fit(l);
      if (ready) draw(l, moving(l) ? offsetNow(performance.now()) : 0);
    });
  }) : null;

  function attach(el) {
    if (el.__snow) return;
    el.style.animation = 'none'; /* the drift is drawn on the canvas; stop the old background-position animation repainting an empty layer */
    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;display:block;pointer-events:none;';
    el.appendChild(canvas);
    var layer = { el: el, canvas: canvas, ctx: canvas.getContext('2d'), visible: !io, w: 0, h: 0, dpr: 1 };
    el.__snow = layer;
    layers.push(layer);
    fit(layer);
    if (ready) draw(layer, 0);
    if (io) io.observe(el);
    if (ro) ro.observe(el);
  }

  function scan() {
    var els = document.querySelectorAll('.launch-snow');
    for (var i = 0; i < els.length; i++) attach(els[i]);
    layers = layers.filter(function (l) { return document.documentElement.contains(l.el); });
  }

  img.decoding = 'async';
  if ('fetchPriority' in img) img.fetchPriority = 'low';
  img.onload = function () {
    ready = true;
    start = performance.now();
    layers.forEach(function (l) { draw(l, 0); });
    kick();
  };
  img.src = src;

  scan();
  document.addEventListener('visibilitychange', kick);
  if (motionQuery && motionQuery.addEventListener) motionQuery.addEventListener('change', kick);
  document.addEventListener('shopify:section:load', function () { scan(); kick(); });
})();
